import AnnouncementBarBody from './AnnouncementBarBody';
import type { AnnouncementBarData } from './AnnouncementBarBody';

export type { AnnouncementBarData };

const AnnouncementBarView = ({ data }: { data: AnnouncementBarData }) => (
  <AnnouncementBarBody data={data} />
);

export default AnnouncementBarView;
